// useMagicLink.ts
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

import backendClient from "src/api";

export const useMagicLink = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const sendMagicLink = (email: string) => {
    backendClient.auth
      .generateEmailChallenge({ email })
      .then(() => {
        enqueueSnackbar("We sent you a login link. Please check your inbox", {
          variant: "success",
        });
        navigate("/magic-link-confirmation-sent", { state: { email } });
      })
      .catch((error) => {
        console.error("Failed to send magic link:", error);
        enqueueSnackbar("Failed to send magic link: " + error.message, {
          variant: "error",
        });
      });
  };

  return sendMagicLink;
};
